import React from "react";
import PropTypes from "prop-types";
import InputAdornment from "@mui/material/InputAdornment";
import FieldLabel from "../../components/label";
import { Alert, Box, TextField, Typography } from "@mui/material";
import { validateInputLength } from "../../helpers/utils";
import { FIELD_LABEL_MOBILE_NUMBER, SLUG_LOGIN } from "../../constants";
import { styled } from "@mui/material/styles";
import { useStyles } from "./indexStyles";
import { withStyles } from "@mui/styles";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    paddingLeft: 0,
  },
  "& .MuiInputAdornment-root": {
    backgroundColor: "#ECF0F4", // theme.palette.divider,
    padding: "28px 14px",
    borderTopLeftRadius: theme.shape.borderRadius + "px",
    borderBottomLeftRadius: theme.shape.borderRadius + "px",
    fontSize: "1rem !important",
  },
  "& .MuiFormHelperText-root": {
    color: "#ff585d",
  },
}));

const LeadInputForm = ({
  classes: { borderContainter, formGroup, mobileInput, mobileInputFocus },
  errorMessage,
  form,
  handleChange,
  onfocusMobile,
  toggleClass,
}) => {
  return (
    <>
      <Box className={formGroup} pt={0}>
        <FieldLabel label={FIELD_LABEL_MOBILE_NUMBER} />
        <CustomTextField
          id="standard-basic"
          variant="outlined"
          value={form.mobile}
          className={!onfocusMobile ? mobileInput : mobileInputFocus}
          name="mobile"
          type="tel"
          onInput={validateInputLength}
          onChange={handleChange}
          onFocus={toggleClass}
          autoComplete="off"
          helperText={errorMessage.mobile}
          inputMode="numeric"
          InputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="subtitle1">+91</Typography>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </>
  );
};

LeadInputForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles, { withTheme: true })(LeadInputForm);
